"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
const react_1 = require("react");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebounce = (callback, delay = 500) => {
    const callbackRef = (0, react_1.useRef)(callback);
    const timeoutRef = (0, react_1.useRef)();
    (0, react_1.useLayoutEffect)(() => {
        callbackRef.current = callback;
    });
    // Initialize the debounced function using useRef to avoid recreating it
    const debouncedFnRef = (0, react_1.useRef)();
    if (!debouncedFnRef.current) {
        debouncedFnRef.current = ((...args) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                callbackRef.current(...args);
            }, delay);
            return undefined;
        });
    }
    // Cleanup on unmount
    (0, react_1.useLayoutEffect)(() => () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, []);
    return debouncedFnRef.current;
};
exports.useDebounce = useDebounce;
